/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import _ from 'lodash';

const config = {
  api: {
    root: 'https://api.voicevibes.io/v1',
  },
  btc: {
    clientId: '5f8e0909979174a2585c0a3efc5c265b',
  },
  vibes: ['Assertive', 'Authentic', 'Captivating', 'Clear', 'Confident',
    'Energetic', 'Organized', 'Personable', 'Persuasive', 'Arrogant', 'Belligerent',
    'Boring', 'Condescending', 'Confusing', 'Detached', 'Ditsy', 'Nervous',
    'Pushy', 'Timid', 'Unapproachable'
  ],
  coreScores: [
    {
      id: 'overall',
      label: 'Overall',
      apiName: 'scoreOverall',
      description: '',
      value: 0,
      order: 1,
      preset: true,
    },
    {
      id: 'organization',
      label: 'Organization and Content',
      apiName: 'scoreOrganization',
      description: 'Content was clearly structured, appropriate and accurate.',
      value: 0,
      order: 2,
      preset: true,
    },
    {
      id: 'delivery',
      label: 'Vocal Delivery',
      apiName: 'scoreDelivery',
      description: 'Polished and smooth oral delivery.',
      value: 0,
      order: 3,
      preset: true,
    },
    {
      id: 'xfactor',
      label: 'X Factor',
      apiName: 'scoreXfactor',
      description: 'I would want to engage with you.',
      value: 0,
      order: 4,
      preset: true,
    },
  ],
  emailNotifications: [
    'recordingSubmittedFrequency',
    'feedbackReceivedFrequency',
    'recordingProcessedFrequency',
    'recordingSharedFrequency',
    'assignmentCompletedFrequency',
    'assignmentReceivedFrequency',
  ],
  assignmentSteps: [
    {stepNum: 1, name: 'description'},
    {stepNum: 2, name: 'criteria'},
    {stepNum: 3, name: 'wordspotting', criteria: 'wordspotting'},
    {stepNum: 4, name: 'scorecard', criteria: 'scorecard'},
    {stepNum: 5, name: 'attachments'},
    {stepNum: 6, name: 'prompt'},
    {stepNum: 7, name: 'assignment'},
  ],
  metaAssignmentCriteria: [],
  assignmentStepsByName: {},
  zoomAuth: 'https://zoom.us/oauth/authorize?response_type=code&client_id=DhByyB2ROGmf_ne3L_LBw&redirect_uri=https://app.myvoicevibes.com/zoom-loading',
};

// Use assignmentSteps to populate metaAssignmentCriteria and assignmentStepsByName
config.assignmentSteps.forEach(
  (step) => {
    if (step.criteria) {
      config.metaAssignmentCriteria.push(step.criteria);
    }
    config.assignmentStepsByName[step.name] = step.stepNum;
  }
);

if (process.env.NODE_ENV !== 'production') {
  _.merge(config, {
    api: {
      root: 'http://localhost:8001'
    },
    btc: {
      clientId: '7f32ff49c7c38978bbd058b7a13c7b7b',
    },
    stripe: {
      key: 'pk_test_EQr5d31Y2ild59If4l1tHMVK'
    },
    zoomAuth: 'https://zoom.us/oauth/authorize?response_type=code&client_id=DhByyB2ROGmf_ne3L_LBw&redirect_uri=http://dand.ngrok.io/zoom-loading',
  });
}

export default config;
